module.exports = __webpack_public_path__ + "static/img/school-9.64b5608.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/school-9.png
// module id = hchC
// module chunks = 1